const urlPagina = window.location.href;
const titlePagina = document.title;
const titleProduct = document.querySelector(`h1.product__title`) || null;
const historial = {
  primeraPaginaUrl: '',
  primeraPaginaTitle: '',
  ultimoProductoUrl: '',
  ultimoProductoTitle: '',
  ultimoProductoTitleVariant: ''
};

const localHistorial = localStorage.getItem('historialContactForm');
if (localHistorial != null){
  let objectHistorial = JSON.parse(localHistorial);
  if (objectHistorial.primeraPaginaUrl == ''){
    objectHistorial.primeraPaginaUrl = urlPagina;
    objectHistorial.primeraPaginaTitle = titlePagina;
  }
  if (urlPagina.includes('products') || urlPagina.includes('PRODUCTS')){
    objectHistorial.ultimoProductoUrl = urlPagina;
    objectHistorial.ultimoProductoTitle = TitleProductSection;
    objectHistorial.ultimoProductoTitleVariant = TitleVariantSection;
  }
  localStorage.setItem('historialContactForm', JSON.stringify(objectHistorial));
} else {
  if (urlPagina.includes('products') || urlPagina.includes('PRODUCTS')){
    historial.primeraPaginaUrl = urlPagina;
    historial.primeraPaginaTitle = titlePagina;
    historial.ultimoProductoUrl = urlPagina;
    historial.ultimoProductoTitle = TitleProductSection;
    historial.ultimoProductoTitleVariant = TitleVariantSection;
  } else {
    historial.primeraPaginaUrl = urlPagina;
    historial.primeraPaginaTitle = titlePagina;
  }
  localStorage.setItem('historialContactForm', JSON.stringify(historial));
}

function updateCookie(varriantCurrent) {
  if (urlPagina.includes('products') || urlPagina.includes('PRODUCTS')){
    historial.primeraPaginaUrl = urlPagina;
    historial.primeraPaginaTitle = titlePagina;
    historial.ultimoProductoUrl = urlPagina;
    historial.ultimoProductoTitle = TitleProductSection;
    if(Boolean(varriantCurrent)){
      historial.ultimoProductoTitleVariant = varriantCurrent.title;
    }
  } else {
    historial.primeraPaginaUrl = urlPagina;
    historial.primeraPaginaTitle = titlePagina;
  }
  localStorage.setItem('historialContactForm', JSON.stringify(historial));
}